import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormControl, UntypedFormArray, UntypedFormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RootStoreState, vaultStoreActions } from '@app/root-store';
import { VaultStoreEffects } from '@app/root-store/vault-store/effects';
import { EditTemplateBasicFormComponent } from '@app/shared/component/discovery-setup-detail/widgets/contact/sub-component/stepper-manage-contact-list/create-associated-form/edit-template-basic-form/edit-template-basic-form.component';
import { loaderTypes } from '@app/shared/component/loader/loader';
import { DocumentService } from '@app/shared/services';
import { SharedVaultService } from '@app/shared/services/vault/shared-vault.service';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'add-entity-vault',
  templateUrl: './add-entity-vault.component.html',
  styleUrl: './add-entity-vault.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddEntityVaultComponent implements OnInit, OnDestroy {
  @Input() isFromVault = false;
  @Input() forms = [];
  @Input() setEntityTypeSuggestion = '';
  @Input() setEntityNameSuggestion = '';
  @Output() setEntityType = new EventEmitter();
  @Output() setEntityName = new EventEmitter();
  @ViewChild(EditTemplateBasicFormComponent) editTemplateBasicForm!: EditTemplateBasicFormComponent;
  @ViewChild('entityInput') entityInput!: ElementRef;
  myControl = new FormControl('');
  options: any = [];
  filteredOptions: Observable<string[]>;
  subscription = new Subscription();
  hideSuffix = false;
  entityType = '';
  ai_suggested_entity: any = '';
  entityName = '';
  selectedEntityType;

  vault_id = '';
  formData = [];
  current_template;
  documentForm;
  securityStateObject;
  vaults = [];
  selectingOption = false;

  constructor(
    public dialogRef: MatDialogRef<AddEntityVaultComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private vaultService: SharedVaultService,
    private store$: Store<RootStoreState.State>,
    private cd: ChangeDetectorRef,
    private documentService: DocumentService,
    private formBuilder: UntypedFormBuilder,
    private vaultService$: VaultStoreEffects
  ) {}

  ngOnInit(): void {
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map((value) => this._filter(value || ''))
    );
    if (!this.isFromVault) {
      this.options = this.data?.stateObject?.forms.filter((f) => f.organization_section === 'Entities');
    } else {
      this.options = this.forms.filter((f) => f.organization_section === 'Entities');
    }
    this.subscription.add(
      this.vaultService$.vaultObject.subscribe((state) => {
        this.vaults = state.vaults;
      })
    );
    if (this.setEntityNameSuggestion) {
      this.entityName = this.setEntityNameSuggestion;
      this.entityNameChange();
    }
    if (this.setEntityTypeSuggestion) {
      let entity = this.forms.find(
        (f) => f.organization_section === 'Entities' && f.type?.toLowerCase() === this.setEntityTypeSuggestion.toLowerCase()
      );
      if (entity) {
        this.ai_suggested_entity = entity;
        this.myControl.setValue(entity.id);
        this.setEntityType.emit(entity);
      }
    }
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.options.filter((option) => option.type.toLowerCase().includes(filterValue));
  }

  closeModel() {
    this.dialogRef.close();
  }

  createformIdForFirstUploadDocument(argument, isShowLoader = true) {
    return new Promise((resolve, reject) => {
      let data = {
        user_id: this.data?.userObject.id,
        vault_form_id: argument.vaultFormId,
        vaultId: argument.vaultId,
        url: 'my-vault/0',
      };
      this.subscription.add(
        this.documentService.getforIdForFirstUploadDocument(data, isShowLoader ? loaderTypes.mainAnimation : loaderTypes.none).subscribe(
          (res) => {
            try {
              this.vault_id = res['vault_user_form_id'].vault_id;
              this.securityStateObject = res['vault_user_form_id'].public_key;
            } catch (error) {}
            if (res.vault_user_form_id.vault_user_form_id) {
              resolve({ vault_form_id: argument.vaultFormId, hub_vault_user_form_id: res.vault_user_form_id.vault_user_form_id, argument });
            }
          },
          (error) => {}
        )
      );
    });
  }

  initFormData(vaultFormId) {
    this.current_template = this.data.stateObject.forms.find((x) => x.id == vaultFormId);
    this.documentForm = this.formBuilder.group({
      documentType: ['', Validators.required],
      documentName: [this.entityName, Validators.required],
      status_progress: ['need to add', Validators.required],
      formSelection: ['', Validators.required],
      selectSaveFolder: ['', Validators.required],
      selectOfficeSaveFolder: ['', Validators.required],
      dynamicFieldsForm: new UntypedFormArray([]),
      beneFicaryForm: new UntypedFormArray([]),
      attributeFormsList: new UntypedFormArray([]),
      showNotes: [''],
      physicalLocation: [''],
      notes: [''],
      expiration_date: [''],
      expiration_notification: [''],
      review_date: [''],
      review_notification: [''],
      renewal_notification: [''],
      renewal_date: [''],
      recurring_expiration: [''],
      value_currency: ['USD'],
      value_current_currency: [''],
      value_is_appraisal: [''],
      value_appraisal_date: [''],
    });
    this.formData = this.current_template.template;
    this.cd.detectChanges();
  }

  updateFormTemplateData(vault_user_form_id, isShowLoader = true) {
    return new Promise(async (resolve, reject) => {
      const payload = {
        id: vault_user_form_id,
        status_progress: 'need to add',
        user_id: this.data?.userObject.id,
        form_data: {
          beneFicaryForm: [],
          dynamicFieldsForm: this.documentForm.controls.dynamicFieldsForm.value[0],
          showNotes: undefined,
        },
        user_pk: this.securityStateObject.public_key,
      };
      this.subscription.add(
        this.documentService.updateFormTampletData(payload, null, undefined, undefined, false, undefined, isShowLoader).subscribe(
          (res) => {
            resolve(res);
          },
          (error) => {}
        )
      );
    });
  }

  formName(hub_vault_user_form_id) {
    return new Promise((resolve) => {
      this.documentForm.controls.dynamicFieldsForm.value[0].foreignDisregardedEntityFullLegalNameofEntity = this.entityName;
      this.subscription.add(
        this.documentService
          .saveNameWithAction(
            {
              form_name: this.entityName,
              id: hub_vault_user_form_id,
              naming_convention: this.current_template.naming_convention,
              dynamicFieldsForm: this.documentForm.controls.dynamicFieldsForm.value[0],
              user_id: this.data?.userObject.id,
              current_template: this.current_template,
              filterArrayItems: this.editTemplateBasicForm.filterArrayItems,
              vault_id: this.vault_id,
              vault_list: this.vaults,
            },
            true
          )
          .subscribe(
            (res) => {
              resolve(res);
            },
            (error) => {}
          )
      );
    });
  }

  toggleSuffix(hide: boolean) {
    if (!this.selectingOption) {
      if (this.entityType) {
        setTimeout(() => {
          this.hideSuffix = hide;
        }, 50);
      } else {
        this.hideSuffix = hide;
      }
    }
  }

  clearValue(event) {
    this.selectingOption = true;
    this.selectedEntityType = {};
    this.entityType = '';
    this.myControl.setValue(null);
    setTimeout(() => {
      this.selectingOption = false;
      this.cd.detectChanges();
    }, 100);
    this.cd.detectChanges();
  }

  selectEntityType(entity) {
    this.selectedEntityType = entity;
    this.setEntityType.emit(entity);
    this.hideSuffix = false;
    setTimeout(() => {
      this.selectingOption = false;
      this.entityType = entity.type;
      if (this.isFromVault) {
        this.setEntityType.emit(entity);
      }
      this.cd.detectChanges();
    }, 0);
    this.cd.detectChanges();
  }

  entityNameChange() {
    this.entityName = this.entityName.trim();
    if (this.isFromVault) {
      this.setEntityName.emit(this.entityName);
    }
  }

  createVault() {
    if (!this.entityName || !this.entityType) return;
    // return;
    let vaultMembers = [];
    vaultMembers.unshift({
      user_email: this.data?.userObject?.email,
      user_id: this.data?.userObject?.id,
      user_profile_image_url: this.data?.userObject?.profile_image_url,
      name: this.data?.userObject?.name,
      user_first_name: this.data?.userObject.first_name,
      type: 'owner',
      is_limited: false,
      isSelected: true,
    });
    const payload = {
      name: this.entityName,
      type: 'entity',
      user_id: this.data?.userObject?.id,
      member: vaultMembers.map(({ user_id, type, is_limited }) => ({ user_id, type, ...(is_limited !== undefined && { is_limited }) })),
    };
    this.subscription.add(
      this.vaultService.createVault(payload).subscribe(
        async (data) => {
          if (data) {
            const formData: any = await this.createformIdForFirstUploadDocument({
              vaultFormId: this.selectedEntityType?.id,
              title: this.selectedEntityType.template,
              vaultType: this.selectedEntityType.template,
              hub_vault_user_form_id: null,
              origin: 'onboarding',
              vaultId: data.id,
            });
            this.formData = [];
            this.cd.detectChanges();
            this.initFormData(formData.vault_form_id);
            const updateRes: any = await this.updateFormTemplateData(formData.hub_vault_user_form_id);
            await this.formName(formData.hub_vault_user_form_id);
            this.store$.dispatch(new vaultStoreActions.GetVaultRequestAction(this.data?.userObject?.id, false));
            this.cd.detectChanges();
            this.dialogRef.close(true);
          }
        },
        (error: any) => {}
      )
    );
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
